"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2886],{

/***/ 42886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _currencyProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4404);
/* harmony import */ var _authProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89149);
/* harmony import */ var _favouritesProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83155);
/* harmony import */ var _modalProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51472);
/* harmony import */ var _SearchContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65079);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40670);








var Providers = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), hydrated = ref[0], setHydrated = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setHydrated(true) // Run only after hydration
        ;
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_currencyProvider__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyContextProvider */ .SF, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_authProvider__WEBPACK_IMPORTED_MODULE_2__/* .AuthContextProvider */ .HD, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchContext__WEBPACK_IMPORTED_MODULE_5__/* .SearchContextProvider */ .Nd, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_favouritesProvider__WEBPACK_IMPORTED_MODULE_3__/* .FavouritesContextProvider */ .td, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modalProvider__WEBPACK_IMPORTED_MODULE_4__/* .ModalContextProvider */ .ny, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__/* .ResponsiveProvider */ .$, {
                            children: hydrated ? children : null
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Providers);


/***/ }),

/***/ 65079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ useSearchContext; },
/* harmony export */   "Nd": function() { return /* binding */ SearchContextProvider; }
/* harmony export */ });
/* unused harmony export SearchContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92375);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79697);
/* harmony import */ var lodash_es_isEqual__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50576);
/* harmony import */ var lodash_es_without__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9092);
/* harmony import */ var lodash_es_omit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70135);














var SearchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)("default");
var useSearchContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(SearchContext);
    if (context === undefined) {
        throw new Error("useSearchContext was used outside of its Provider");
    }
    return context;
};
function SearchContextProvider(param) {
    var children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var initialValues = {
        startDate: null,
        endDate: null,
        bedrooms: null,
        bathrooms: null,
        priceStart: null,
        priceEnd: null,
        amenities: [],
        homeType: [],
        location: [],
        listing: "",
        sorting: "default"
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isFirstVisit = ref[0], setIsFirstVisit = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), listing = ref1[0], setListing = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), urlParams = ref3[0], setUrlParams = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), reset = ref4[0], setReset = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), offsetable = ref5[0], setOffsetable = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), searchActive = ref6[0], setSearchActive = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loaded = ref7[0], setLoaded = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialValues), search = ref8[0], setSearch = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), reserved = ref9[0], setReserved = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(moment__WEBPACK_IMPORTED_MODULE_5___default()().utc()), requestStartDate = ref10[0], setRequestStartDate = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(moment__WEBPACK_IMPORTED_MODULE_5___default()().utc()), requestEndDate = ref11[0], setRequestEndDate = ref11[1];
    var isCalendarPage = router.asPath === "/calendar";
    // for single page
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), bedroomOptions = ref12[0], setBedroomOptions = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), guests = ref13[0], setGuests = ref13[1];
    var activeRoute = router.pathname === "/vacation-rentals" || router.pathname === "/real-estate/search" || router.pathname === "/calendar";
    var searchRoute = router.pathname === "/calendar" ? "calendar/search" : router.pathname === "/vacation-rentals" ? "listings/search" : "real-estate/search";
    var allPropertiesRoute = router.pathname === "/calendar" ? "calendar/blocked-dates" : router.pathname === "/vacation-rentals" ? "listings/index" : "real-estate/properties";
    var hasInitialValuesInQuery = function() {
        return Object.keys(initialValues).some(function(key) {
            return key in router.query;
        });
    };
    // enable the search on the search/real estate pages
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        !activeRoute && setSearchActive(false);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!activeRoute) {
            setSearch(initialValues);
        } else {
            if ((0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(router.query)) {
                setSearch(initialValues);
            }
        }
    }, [
        router.asPath
    ]);
    //set the search if there are url params
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(router.query)) {
            var _query = router.query, startDate = _query.startDate, endDate = _query.endDate, bedrooms = _query.bedrooms, bathrooms = _query.bathrooms, priceStart = _query.priceStart, priceEnd = _query.priceEnd, homeType = _query.homeType, location = _query.location, listing = _query.listing, amenities = _query.amenities, sorting = _query.sorting;
            if (activeRoute) {
                setSearch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, search), {
                    location: typeof location === "string" ? [
                        location
                    ] : !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(location) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(location) : initialValues.location,
                    amenities: typeof amenities === "string" ? [
                        amenities
                    ] : !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(amenities) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(amenities) : initialValues.amenities,
                    homeType: typeof homeType === "string" ? [
                        homeType
                    ] : !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(homeType) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(homeType) : initialValues.homeType,
                    priceStart: priceStart ? Number(priceStart) : initialValues.priceStart,
                    priceEnd: priceEnd ? Number(priceEnd) : initialValues.priceEnd,
                    bedrooms: bedrooms ? Number(bedrooms) : initialValues.bedrooms,
                    bathrooms: bathrooms ? Number(bathrooms) : initialValues.bathrooms,
                    startDate: startDate ? moment__WEBPACK_IMPORTED_MODULE_5___default()(startDate).utc() : initialValues.startDate,
                    endDate: endDate ? moment__WEBPACK_IMPORTED_MODULE_5___default()(endDate).utc() : initialValues.endDate,
                    listing: listing ? listing : initialValues.listing,
                    sorting: sorting ? sorting : initialValues.sorting
                }));
            }
        }
    }, [
        router.isReady,
        router.asPath
    ]);
    // build the url params
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (activeRoute) {
            var filtered = Object.keys(initialValues).filter(function(key) {
                return !(0,lodash_es_isEqual__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(search[key], initialValues[key]);
            }).reduce(function(obj, key) {
                obj[key] = search[key];
                return obj;
            }, {});
            var filteredQuery = (0,lodash_es_omit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(router.query, Object.keys(initialValues));
            if (filtered.startDate && moment__WEBPACK_IMPORTED_MODULE_5___default().isMoment(filtered.startDate)) {
                var ref;
                filtered.startDate = (ref = filtered.startDate) === null || ref === void 0 ? void 0 : ref.toISOString();
            }
            if (filtered.endDate && moment__WEBPACK_IMPORTED_MODULE_5___default().isMoment(filtered.endDate)) {
                var ref1;
                filtered.endDate = (ref1 = filtered.endDate) === null || ref1 === void 0 ? void 0 : ref1.toISOString();
            }
            if (isFirstVisit) {
                setUrlParams(filteredQuery);
            }
            if (!(0,lodash_es_isEqual__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(urlParams, filtered) && activeRoute) {
                setUrlParams((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, filtered));
                if (!(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(urlParams)) {
                    setUrlParams(filtered);
                }
            }
            setIsFirstVisit(false);
        }
    }, [
        search
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return setLoaded(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var fetchAllProperties = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var params;
                return _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setLoading(true);
                            params = {
                                lang: router.locale,
                                startDate: isCalendarPage && requestStartDate && (requestStartDate === null || requestStartDate === void 0 ? void 0 : requestStartDate._d) || moment__WEBPACK_IMPORTED_MODULE_5___default()().utc().format("YYYY-MM-DD"),
                                endDate: isCalendarPage && requestEndDate && (requestEndDate === null || requestEndDate === void 0 ? void 0 : requestEndDate._d) || moment__WEBPACK_IMPORTED_MODULE_5___default()().utc().add(2, "years").format("YYYY-MM-DD")
                            };
                            if (router.pathname === "/calendar") {
                                delete params.lang;
                            }
                            _ctx.next = 5;
                            return _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(allPropertiesRoute, {
                                params: params
                            }).then(function(res) {
                                if ((0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(res.data)) {
                                    setListing(res.data);
                                } else {
                                    setListing(res.data[router.locale]);
                                }
                                setLoading(false);
                            }).catch(function(error) {
                                if (error) {
                                    console.error(error);
                                    setListing([]);
                                    setLoading(false);
                                }
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchAllProperties() {
                return _ref.apply(this, arguments);
            };
        }();
        if ((0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(urlParams) && router.isReady && !hasInitialValuesInQuery() && loaded && activeRoute) {
            fetchAllProperties();
        }
    }, [
        reset,
        loaded,
        urlParams,
        router.isReady,
        activeRoute,
        router.asPath,
        router.locale,
        requestStartDate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var searchProperties = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, ref1, submittedStart, submittedEnd, submittedHomeType, params;
                return _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            submittedStart = search.startDate && search.startDate.clone();
                            submittedEnd = submittedStart && search.endDate && search.endDate.clone();
                            submittedHomeType = (0,lodash_es_without__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(search === null || search === void 0 ? void 0 : search.homeType, "exclusive");
                            setLoading(true);
                            params = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, search), {
                                lang: router.locale,
                                homeType: submittedHomeType,
                                exclusive: (search === null || search === void 0 ? void 0 : search.homeType.includes("exclusive")) ? true : null,
                                priceStart: search.priceStart || 0,
                                priceEnd: search.priceEnd || 60000,
                                startDate: isCalendarPage && (requestStartDate === null || requestStartDate === void 0 ? void 0 : requestStartDate._d) ? requestStartDate : submittedStart ? (ref = submittedStart === null || submittedStart === void 0 ? void 0 : submittedStart.subtract(offsetable, "days")) === null || ref === void 0 ? void 0 : ref.format("YYYY-MM-DD") : null,
                                endDate: isCalendarPage && (requestEndDate === null || requestEndDate === void 0 ? void 0 : requestEndDate._d) ? requestEndDate : submittedEnd ? (ref1 = submittedEnd === null || submittedEnd === void 0 ? void 0 : submittedEnd.add(offsetable, "days")) === null || ref1 === void 0 ? void 0 : ref1.format("YYYY-MM-DD") : null
                            });
                            _ctx.next = 8;
                            return _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(searchRoute, {
                                params: params
                            }).then(function(res) {
                                if ((0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(res.data)) {
                                    setListing(res.data);
                                } else {
                                    setListing(res.data[router.locale]);
                                }
                                setLoading(false);
                            }).catch(function(error) {
                                if (error) {
                                    console.error(error);
                                    setListing([]);
                                    setLoading(false);
                                }
                            });
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function searchProperties() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(urlParams) && activeRoute) {
            searchProperties();
        }
    }, [
        urlParams,
        requestStartDate,
        router.locale
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SearchContext.Provider, {
        value: {
            listing: listing,
            setListing: setListing,
            search: search,
            setSearch: setSearch,
            loading: loading,
            initialValues: initialValues,
            reset: reset,
            setReset: setReset,
            urlParams: urlParams,
            offsetable: offsetable,
            setOffsetable: setOffsetable,
            bedroomOptions: bedroomOptions,
            setBedroomOptions: setBedroomOptions,
            guests: guests,
            setGuests: setGuests,
            searchActive: searchActive,
            setSearchActive: setSearchActive,
            setReserved: setReserved,
            reserved: reserved,
            setRequestEndDate: setRequestEndDate,
            setRequestStartDate: setRequestStartDate
        },
        children: children
    });
}



/***/ }),

/***/ 89149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eu": function() { return /* binding */ useAuthContext; },
/* harmony export */   "HD": function() { return /* binding */ AuthContextProvider; }
/* harmony export */ });
/* unused harmony export AuthContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var AuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useAuthContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AuthContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var AuthContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isAgent = ref1[0], seIsAgent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), user = ref2[0], setUser = ref2[1];
    var isAuthorized = loggedIn && isAgent;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // When storage changes refetch
        setLoggedIn(localStorage.getItem("access_token") || false);
        seIsAgent(localStorage.getItem("isAgent") || false);
        setUser(localStorage.getItem("user") || false);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthContext.Provider, {
        value: {
            loggedIn: loggedIn,
            setLoggedIn: setLoggedIn,
            isAgent: isAgent,
            seIsAgent: seIsAgent,
            isAuthorized: isAuthorized,
            user: user,
            setUser: setUser
        },
        children: children
    });
};



/***/ }),

/***/ 4404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SF": function() { return /* binding */ CurrencyContextProvider; },
/* harmony export */   "VT": function() { return /* binding */ useCurrencyContext; }
/* harmony export */ });
/* unused harmony export CurrencyContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var CurrencyContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useCurrencyContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CurrencyContext);
    if (context === undefined) {
        throw new Error("useCurrencyContext was used outside of its Provider");
    }
    return context;
};
var CurrencyContextProvider = function(param) {
    var children = param.children;
    var defaultValue = "usd";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultValue), currency = ref[0], setCurrency = ref[1];
    var currencies = [
        {
            value: "usd",
            label: "$ USD",
            coin: "$"
        },
        {
            value: "eur",
            label: "€ EUR",
            coin: "€"
        }
    ];
    var selectedCurrency = currencies.find(function(item) {
        return item.value === currency;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CurrencyContext.Provider, {
        value: {
            currency: currency,
            setCurrency: setCurrency,
            currencies: currencies,
            defaultValue: defaultValue,
            selectedCurrency: selectedCurrency
        },
        children: children
    });
};



/***/ }),

/***/ 83155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ useFavouritesContext; },
/* harmony export */   "td": function() { return /* binding */ FavouritesContextProvider; }
/* harmony export */ });
/* unused harmony export FavouritesContext */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_es_pull__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35242);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92375);
/* harmony import */ var _authProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89149);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79697);







var FavouritesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useFavouritesContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FavouritesContext);
    if (context === undefined) {
        throw new Error("useCurrencyContext was used outside of its Provider");
    }
    return context;
};
var FavouritesContextProvider = function(param) {
    var children = param.children;
    var isFavourite = function isFavourite(value) {
        return favourites.includes(value);
    };
    var saveFavouritesInDB = function saveFavouritesInDB() {
        _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("user/favourites/update", {
            user_id: user,
            favourites: favourites
        }).catch(function(err) {
            return console.error(err);
        });
    };
    var getFavouritesInDB = function getFavouritesInDB() {
        _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("user/".concat(user, "/favourites")).then(function(res) {
            setFavourites(res.data.favourites);
            localStorage.setItem("favourites", res.data.favourites);
        }).catch(function(err) {
            return console.error(err);
        });
    };
    var addOrRemoveFavourite = function addOrRemoveFavourite(value) {
        var newFavourites = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(favourites);
        if (isFavourite(value)) {
            (0,lodash_es_pull__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(newFavourites, value);
        } else {
            newFavourites.push(value);
        }
        setFavourites(newFavourites);
        localStorage.setItem("favourites", favourites);
        if (loggedIn) {
            saveFavouritesInDB();
        }
    };
    var refreshFavourites = function refreshFavourites() {
        if (loggedIn) {
            if (!(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(favourites)) {
                saveFavouritesInDB();
            }
            getFavouritesInDB();
        } else if (typeof localStorage !== "undefined") {
            var ref;
            localStorage.getItem("favourites") !== "" && setFavourites(((ref = localStorage.getItem("favourites")) === null || ref === void 0 ? void 0 : ref.split(",")) || []);
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), favourites = ref[0], setFavourites = ref[1];
    var ref1 = (0,_authProvider__WEBPACK_IMPORTED_MODULE_3__/* .useAuthContext */ .Eu)(), user = ref1.user, loggedIn = ref1.loggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        refreshFavourites();
    }, [
        loggedIn
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FavouritesContext.Provider, {
        value: {
            favourites: favourites,
            isFavourite: isFavourite,
            addOrRemoveFavourite: addOrRemoveFavourite
        },
        children: children
    });
};



/***/ }),

/***/ 51472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ny": function() { return /* binding */ ModalContextProvider; },
/* harmony export */   "vR": function() { return /* binding */ useModalContext; }
/* harmony export */ });
/* unused harmony export ModalContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useModalContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var ModalContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), variant = ref2[0], setVariant = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), beforeClose = ref3[0], handleBeforeClose = ref3[1];
    var body =  true && document.querySelector("body");
    var handleShowModal = function() {
        setShow(true);
        body.classList.add("modal-open");
    };
    var handleCloseModal = function() {
        setShow(false);
        body.classList.remove("modal-open");
        // Clear content to reset state when modal closes
        // This ensures errors and form state are cleared for next opening
        setContent(false);
        setVariant([]);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) {
            beforeClose && beforeClose();
            handleCloseModal();
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: {
            handleShowModal: handleShowModal,
            handleCloseModal: handleCloseModal,
            handleBeforeClose: handleBeforeClose,
            setContent: setContent,
            content: content,
            setVariant: setVariant,
            show: show,
            variant: variant
        },
        children: children
    });
};



/***/ }),

/***/ 35242:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_pull; }
});

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseRest.js
var _baseRest = __webpack_require__(69581);
// EXTERNAL MODULE: ./node_modules/lodash-es/_arrayMap.js
var _arrayMap = __webpack_require__(74073);
// EXTERNAL MODULE: ./node_modules/lodash-es/_baseIndexOf.js + 3 modules
var _baseIndexOf = __webpack_require__(36333);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIndexOfWith.js
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var _baseIndexOfWith = (baseIndexOfWith);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseUnary.js
var _baseUnary = __webpack_require__(21162);
// EXTERNAL MODULE: ./node_modules/lodash-es/_copyArray.js
var _copyArray = __webpack_require__(87215);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_basePullAll.js






/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? _baseIndexOfWith : _baseIndexOf/* default */.Z,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = (0,_copyArray/* default */.Z)(values);
  }
  if (iteratee) {
    seen = (0,_arrayMap/* default */.Z)(array, (0,_baseUnary/* default */.Z)(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

/* harmony default export */ var _basePullAll = (basePullAll);

;// CONCATENATED MODULE: ./node_modules/lodash-es/pullAll.js


/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values)
    : array;
}

/* harmony default export */ var lodash_es_pullAll = (pullAll);

;// CONCATENATED MODULE: ./node_modules/lodash-es/pull.js



/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = (0,_baseRest/* default */.Z)(lodash_es_pullAll);

/* harmony default export */ var lodash_es_pull = (pull);


/***/ })

}]);